import Grid from "@mui/material/Unstable_Grid2";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import { DataGrid, GridColDef } from "@mui/x-data-grid";

import {
  InstitutionNetworkErrors,
  InstitutionNotifications,
  alphabetizeInstitutions,
  useAllInstitutions
} from "./institutionUtils";
import { PageWrapper, PageWrapperProps } from "../../common-ui/PageWrapper";
import { Box } from "@mui/material";
import { DataGridErrorOverlay } from "../../common-ui/DataGridErrorOverlay";

const pageDetails: PageWrapperProps = {
  className: "Institutions",
  headerText: "Institutions"
};

export const Institutions = ({
  disableVirtualization
}: {
  disableVirtualization?: boolean;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { institutions, status, error } = useAllInstitutions();
  const alphabetizedInstitutions = institutions
    ? alphabetizeInstitutions(institutions)
    : institutions;

  const columns: GridColDef[] = [
    {
      headerName: t("Name"),
      field: "name",
      flex: 1
    },
    {
      headerName: t("Description"),
      field: "description",
      flex: 1
    },
    {
      headerName: t("Date Created"),
      field: "createdAt",
      flex: 1,
      renderCell: (params) => {
        const { row } = params;
        const { createdAt } = row;
        return format(new Date(createdAt), "MMM do, yyyy");
      }
    },
    {
      headerName: t("ID"),
      field: "id",
      flex: 1
    }
  ];

  return (
    <PageWrapper {...pageDetails}>
      <div>
        <button onClick={() => navigate("/institutions/new")}>
          {t("New Institution")}
        </button>
      </div>

      {(status === "failed" || error) && (
        <DataGridErrorOverlay
          errorMessage={InstitutionNetworkErrors.FetchAllInstitutionsError}
        />
      )}
      <DataGrid
        columns={columns}
        rows={alphabetizedInstitutions || []}
        aria-label="institutions-table"
        disableVirtualization={disableVirtualization}
        loading={status === "loading"}
        localeText={{
          noRowsLabel: t(InstitutionNotifications.NoInstitutions)
        }}
        onRowClick={(rowData) => {
          const { row } = rowData;
          const { id } = row;
          if (id) {
            navigate(`${id}`);
          }
        }}
      />
    </PageWrapper>
  );
};
